import React from "react";

import { useTranslation } from "react-i18next";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/ui/select";

import AnalyticsPeriodPicker from "../charts/AnalyticsPeriodPicker";

import type { Moment } from "moment";
import type { JSX } from "react";

import type {
  OfferAnalyticsFilterValues,
  OfferOption,
} from "./offerAnalytics.types";

const ALL_OFFERS_VALUE = "all";

interface OfferAnalyticsFiltersProps {
  filters: OfferAnalyticsFilterValues;
  offerOptionList: readonly OfferOption[];
  onPeriodChange: (startDate: Moment, endDate: Moment) => void;
  onOfferChange: (offerUuid?: string) => void;
}

function OfferAnalyticsFilters({
  filters,
  offerOptionList,
  onPeriodChange,
  onOfferChange,
}: OfferAnalyticsFiltersProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  const handleOfferChange = (value: string): void => {
    onOfferChange(value === ALL_OFFERS_VALUE ? undefined : value);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <AnalyticsPeriodPicker onChange={onPeriodChange} period={filters} />
      <Select
        onValueChange={handleOfferChange}
        value={filters.offerUuid ?? ALL_OFFERS_VALUE}
      >
        <SelectTrigger
          aria-label={t("offerAnalytics.offerFilter")}
          className="bg-card hover:bg-muted dark:bg-card w-64"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent align="end">
          <SelectItem value={ALL_OFFERS_VALUE}>{t("all_offers")}</SelectItem>
          {offerOptionList.map((offerOption) => (
            <SelectItem key={offerOption.value} value={offerOption.value}>
              {offerOption.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default OfferAnalyticsFilters;
